import axios from "axios";

const rawBaseURL = process.env.REACT_APP_API_URL || "http://localhost:8081";
const baseURL = String(rawBaseURL).replace(/\/+$/, "");

const clienteAxios = axios.create({
  baseURL,
  timeout: Number(process.env.REACT_APP_API_TIMEOUT_MS || 150000),
});

// Compatibilidad de despliegue:
// En este proyecto las llamadas vienen como /api/..., pero algunos .env pueden traer
// REACT_APP_API_URL terminando en /api. Si no normalizamos, queda /api/api/... y el backend responde 404.
clienteAxios.interceptors.request.use((config) => {
  if (config && typeof config.url === "string" && /\/api$/.test(baseURL) && config.url.indexOf("/api/") === 0) {
    config.url = config.url.replace(/^\/api/, "");
  }
  return config;
});

export default clienteAxios;
